import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteDep = ({children}) => {
    const rol = localStorage.getItem('rol');
    if (rol === 'DEPENDENCIA') {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }
    
}

export default PrivateRouteDep;
